import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const FeedSearch = ({ value, onChange }: Props) => (
  <div className="flex h-10 w-[280px] items-center gap-4 rounded-[10px] border border-transparent bg-white px-4 py-1 focus-within:border-[#5F1ECC]">
    <FontAwesomeIcon
      icon={faMagnifyingGlass}
      className="shrink-0 text-[18px] text-[#9E9E9E]"
    />
    <input
      type="text"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Search"
      aria-label="Search posts"
      className="min-w-0 flex-1 bg-transparent text-base font-medium leading-6 text-[#131313] outline-none placeholder:text-[#9E9E9E]"
    />
  </div>
);
